import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { dataStorageKeywords, routeURL } from 'src/utils/properties.utils';
import { getEncryptedLocalStorageData } from 'src/utils/dataStorageManagement.utils';

interface LoginCheckProps {
  element: JSX.Element;
}

export const LoginCheck: FC<LoginCheckProps> = ({ element }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyLogin = async () => {
      const isLoggedIn = await getEncryptedLocalStorageData(
        dataStorageKeywords.IS_LOGGED_IN
      );

      if (!isLoggedIn) {
        navigate(routeURL.LOGIN);
        return;
      }
      setLoading(false);
    };

    verifyLogin();
  }, [navigate]);

  if (loading) {
    return null;
  }

  return element;
};
